var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gauge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 23.0001V20.1376C3 12.9501 8.775 7.0251 15.95 7.0001C17.6614 6.99351 19.3572 7.32491 20.9402 7.97527C22.5232 8.62564 23.9623 9.58217 25.1747 10.79C26.3872 11.9978 27.3492 13.4331 28.0057 15.0136C28.6621 16.5941 29 18.2887 29 20.0001V23.0001C29 23.2653 28.8946 23.5197 28.7071 23.7072C28.5196 23.8947 28.2652 24.0001 28 24.0001H4C3.73478 24.0001 3.48043 23.8947 3.29289 23.7072C3.10536 23.5197 3 23.2653 3 23.0001Z",
    stroke: "#A2A2A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 7V11",
    stroke: "#A2A2A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.4375 16.6367L7.3125 17.6742",
    stroke: "#A2A2A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.5625 16.6367L24.6875 17.6742",
    stroke: "#A2A2A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.925 24.0008L21.475 12.8633",
    stroke: "#A2A2A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.3e313e245dda1d9b392a33363d08265f.svg";
export { ForwardRef as ReactComponent };